import * as types from "../actionTypes";

export const setFinanceAnalyticsByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_FINANCE_ANALYTICS_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setFinanceAnalyticsByMonths = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_FINANCE_ANALYTICS_BY_MONTHS,
      key,
      yearKey,
      amount,
    });
  };
};

export const replaceFinanceAnalyticsYears = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_FINANCE_ANALYTICS_YEARS,
      key,
      payload,
    });
  };
};

export const resetFinanceAnalyticsReducer = () => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_FINANCE_ANALYTICS_REDUCER,
    });
  };
};
